import { useCallback, useRef } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const SuprailiacInput: React.FC = () => {
  const suprailiacRef = useRef(evaluationAtom.get()?.suprailiac ?? [])

  const handleUpdateField = useCallback(
    (index: number, value: number) => {
      const newArr = [...suprailiacRef.current]
      newArr[index] = value
      suprailiacRef.current = newArr
      patchEvaluationAtom({ suprailiac: newArr })
    },
    [],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(7)
  }, [])

  return (
    <>
      <div className='whitespace-nowrap font-bold xl:font-normal'>
        Supra-Ilíaca (mm) &nbsp;
      </div>
      {suprailiacRef.current.map((val, index) => (
        <div key={`suprailiac-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            value={val}
            placeholder='0'
            mask='integer'
            onFocus={handleFocus}
            inputMode='numeric'
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='suprailiac' />
      </div>
    </>
  )
}
